var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeTrend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6177 32H7.38233C3.30419 32 0 28.6773 0 24.5947V13.5538C0 11.5274 1.25023 8.97953 2.85767 7.72793L10.88 1.46994C13.2912 -0.40746 17.146 -0.49686 19.6465 1.26134L28.8447 7.71303C30.6158 8.94973 32 11.6019 32 13.7624V24.6096C32 28.6773 28.6958 32 24.6177 32ZM12.2493 3.22814L4.22698 9.48613C3.17023 10.3205 2.23256 12.2128 2.23256 13.5538V24.5947C2.23256 27.4406 4.53954 29.765 7.38233 29.765H24.6177C27.4605 29.765 29.7674 27.4555 29.7674 24.6096V13.7624C29.7674 12.332 28.7405 10.3503 27.5647 9.54573L18.3665 3.09404C16.6698 1.90204 13.8716 1.96164 12.2493 3.22814Z",
    fill: "#0195D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30396 23.8219C9.02117 23.8219 8.73838 23.7176 8.51513 23.4941C8.0835 23.062 8.0835 22.3468 8.51513 21.9147L13.2779 17.1467C13.5161 16.9083 13.8286 16.7891 14.1709 16.8189C14.4984 16.8487 14.7961 17.0275 14.9895 17.3106L16.6119 19.7542L21.8956 14.4647C22.3272 14.0326 23.0416 14.0326 23.4733 14.4647C23.9049 14.8968 23.9049 15.612 23.4733 16.0441L17.2221 22.3021C16.984 22.5405 16.6714 22.6597 16.3291 22.6299C16.0016 22.6001 15.704 22.4213 15.5105 22.1382L13.8882 19.6946L10.0928 23.4941C9.86955 23.7176 9.58676 23.8219 9.30396 23.8219Z",
    fill: "#0195D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6985 19.3478C22.0883 19.3478 21.5822 18.8412 21.5822 18.2303V16.3678H19.7217C19.1115 16.3678 18.6055 15.8612 18.6055 15.2503C18.6055 14.6394 19.1115 14.1328 19.7217 14.1328H22.6985C23.3087 14.1328 23.8148 14.6394 23.8148 15.2503V18.2303C23.8148 18.8412 23.3087 19.3478 22.6985 19.3478Z",
    fill: "#0195D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTrend);
export default __webpack_public_path__ + "static/media/home-trend.100c5d2db1336ec6e7de9f629770da0d.svg";
export { ForwardRef as ReactComponent };